export default {
  picks: {
    title: "Meine Tipps",
    actions: {
      selectLocation: "Standort auswählen",
      importPhoto: "Foto importieren",
      takePhoto: "Foto aufnehmen",
      selectOperatorToContinue: "Anbieter auswählen, um fortzufahren",
      openOn: "Auf {{operator}} öffnen",
      visit: "{{operator}} besuchen",
    },
    locationGate: {
      title: "Erlaube Linemate den Zugriff auf deinen Standort, um Meine Tipps zu nutzen",
      subtitle: "Linemate nutzt deinen Standort, um Märkte und Angebote in deiner Region anzuzeigen.",
    },
    empty: {
      title: "Noch keine Tipps",
      subtitle: "Tippe auf einen Trend, um ihn hinzuzufügen, oder teile einfach ein Foto und wir erfassen die Tipps für dich.",
    },
    imageImport: {
      title: "Tipps importieren",
      scanningBetslip: "Dein Betslip wird gescannt...",
      analyzingImage: "Dein Bild wird analysiert...",
      detectingOdds: "Quoten werden erkannt",
      failed: "Tipps konnten nicht importiert werden",
      pleaseTryAgain: "Bitte versuche es erneut",
      tryAgain: "Erneut versuchen",
    },
    labels: {
      parlay: "Kombiwette",
      sgp: "SGP",
      straight: "Einzelwette",
      legParlay: "{{count}}-Leg-Kombiwette",
      pricingUnavailable: "Preis nicht verfügbar",
      continueToOperator: "Weiter zu deinem Anbieter",
    },
    sections: {
      availableOrAdjusted: "Alle Props verfügbar oder angepasst",
      missingProps: "Fehlende Props",
      unavailableInRegion: "In deiner Region nicht verfügbar",
    },
    warnings: {
      legsNotFound_one: "{{count}} Leg konnte nicht gefunden werden",
      legsNotFound_other: "{{count}} Legs konnten nicht gefunden werden",
      adjusted_one: "{{count}} Leg wurde angepasst",
      adjusted_other: "{{count}} Legs wurden angepasst",
      and: " und ",
      forOperator: " für {{operator}}.",
    },
  },
};
